import React, { createContext } from 'react';

export const ImagenesContext = createContext();